import * as React from 'react';
import { trackCriteoCartView } from '@reverbdotcom/commons/dist/criteo';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import { MParticlePageName, trackPageView } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';
import { buildCheckoutPageView, fetchCartItems } from '../shared/checkout_events';
import { IUser } from '@reverbdotcom/commons/dist/components/user_context_provider';

async function trackCartView(user: Partial<IUser>) {

  const cartItems = await fetchCartItems();

  trackPageView(
    buildCheckoutPageView({
      pageName: MParticlePageName.Cart,
      cartItems,
      user,
    }),
  );

  const items = cartItems.map(item => ({
    id: item.product_id.toString(),
    price: item.item_price.amount,
    quantity: item.quantity || 1,
  }));
  trackCriteoCartView(items, user);
}

export default function TrackCartView() {
  const user = useUser();

  // Only runs once
  React.useEffect(() => {
    trackCartView(user);
  }, [user]);

  return null;
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/cart/track_cart_view.tsx